import { differenceInMilliseconds, setHours, startOfToday } from "date-fns";
import React from "react";
import { HOUR_MILLIS, MINUTE_MILLIS } from "@fidget/common/utils/timeUtils";
import styles from "./calendarColumn.css";

interface State {
  top: number | undefined;
}

export class CurrentTimeIndicator extends React.Component<{}, State> {
  private currentTimeIndicatorTimer?: number;
  private indicatorElement?: HTMLElement;

  constructor(props: {}) {
    super(props);
    this.state = {
      top: undefined
    };
  }

  computePosition() {
    this.setState({ top: this.indicatorPosition() }, () => {
      if (this.indicatorElement) {
        this.indicatorElement.scrollIntoView({ block: "center" });
      }
    });
    clearInterval(this.currentTimeIndicatorTimer);
    this.currentTimeIndicatorTimer = window.setInterval(() => {
      this.setState({ top: this.indicatorPosition() });
    }, 5 * MINUTE_MILLIS);
  }

  componentDidMount() {
    this.computePosition();
  }

  componentWillUnmount() {
    clearInterval(this.currentTimeIndicatorTimer);
  }

  private indicatorPosition(): number {
    const timeSinceStart = differenceInMilliseconds(new Date(), setHours(startOfToday(), 0));
    const timeSpan = 24 * HOUR_MILLIS;
    return timeSinceStart / timeSpan;
  }

  render() {
    return this.state.top ? (
      <div
        className={styles["current-time-indicator"]}
        style={{ top: (this.state.top * 100).toString() + "%" }}
        ref={(e) => (this.indicatorElement = e || undefined)}
      />
    ) : (
      <div />
    );
  }
}
